"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var reactPopover = require('@radix-ui/react-popover');
var e = require('styled-components');
var react = require('react');
var faXmark = require('@fortawesome/free-solid-svg-icons/faXmark');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var e__default = /*#__PURE__*/_interopDefaultLegacy(e);

var p=e__default["default"](reactPopover.Content)`
  @keyframes slideUpAndFade {
    from {
      opacity: 0;
      transform: translateY(2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideRightAndFade {
    from {
      opacity: 0;
      transform: translateX(-2px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideDownAndFade {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes slideLeftAndFade {
    from {
      opacity: 0;
      transform: translateX(2px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  box-sizing: border-box;
  background-color: var(--background-level-3);
  border-radius: var(--border-radius-small);
  box-shadow: var(--elevation-300);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  max-width: 416px;
  min-width: 248px;
  z-index: var(--z-index-300);
  padding: var(--spacing-large);

  :focus {
    box-shadow: var(--elevation-300);
  }

  &[data-state='open'][data-side='top'] {
    animation-name: slideDownAndFade;
  }
  &[data-state='open'][data-side='right'] {
    animation-name: slideLeftAndFade;
  }
  &[data-state='open'][data-side='bottom'] {
    animation-name: slideUpAndFade;
  }
  &[data-state='open'][data-side='left'] {
    animation-name: slideRightAndFade;
  }
`,l=e__default["default"](reactPopover.Arrow)`
  fill: var(--background-level-3);
`,d=e__default["default"](reactPopover.Close).attrs({"aria-label":"Close"})`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border: none;
  cursor: pointer;
  background: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`,m=e__default["default"](chunk2VCHSK65_js.d).attrs({size:"medium",weight:"semibold",colorToken:"foreground-primary"})``,c=e__default["default"](chunk2VCHSK65_js.d).attrs({size:"regular",colorToken:"foreground-secondary"})`
  padding-top: var(--spacing-small);
  padding-bottom: var(--spacing-small);
`,f=e__default["default"].div`
  display: flex;
  justify-content: right;
  border: none;
  background: none;
`;var P=react.forwardRef(({onDismiss:t,children:r},n)=>jsxRuntime.jsx(d,{ref:n,onClick:t,children:r})),g=t=>jsxRuntime.jsx(chunkLXX3SSRV_js.b,{size:"small",icon:faXmark.faXmark,colorToken:"foreground-primary",...t});var o=({open:t,trigger:r,disabled:n,children:v,onOpenChange:x,onOpenAutoFocus:b,caret:y=!0,align:h="center",placement:T="top",container:A=document.body,...k})=>jsxRuntime.jsxs(reactPopover.Root,{open:t,onOpenChange:x,...k,children:[jsxRuntime.jsx(reactPopover.Trigger,{asChild:!0,disabled:n,children:r}),jsxRuntime.jsx(reactPopover.Portal,{container:A,children:jsxRuntime.jsxs(p,{sideOffset:4,side:T,align:h,onOpenAutoFocus:b,children:[v,y&&jsxRuntime.jsx(l,{width:16,height:8})]})})]});o.Root=e__default["default"](o)``;o.Title=m;o.Description=c;o.Action=f;o.Close=P;o.IconClose=g;o.displayName="Popover";var I=o;

exports.a = I;
